module.exports = __webpack_public_path__ + "static/item-6-f62370a35f8f32530478f42e73a60f60.jpeg";